jQuery( function($) { 
	$(document).ready( function () {
		/**
		* Add payment method form.
		*/
		$("form#add_payment_method").on('submit', onSubmit);

		/**
		* Pay for order form.
		*/
		$("form#order_review").on('submit', onSubmit);

		/**
		* Regular Checkout form.
		*/
		$("form.woocommerce-checkout").on('checkout_place_order_sumup', onSubmit);

		/**
		* Get client and customer id promise.
		*/
		function getClientAndCustomerId( form ){
			var deferredObject = $.Deferred();

			if( woocommerce_sumup_gateway_general_params.customer_id ) {
				deferredObject.resolve( woocommerce_sumup_gateway_general_params.customer_id );
			} else {
				var email = form.find('input#billing_email');
				email = email.length ? email.val() : false;
				$.ajax({
					url: woocommerce_sumup_gateway_general_params.ajax_url,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'sumup_get_api_data',
						user_email: email,
					},
					success: function( response ) {
						if( response.success ){
							woocommerce_sumup_gateway_general_params.customer_id = response.data.customer_id;
							deferredObject.resolve( response.data.customer_id );
						} else {
							deferredObject.reject( response.data );
						}
					},
					error: function( error ) {
						 deferredObject.reject( error );
					}
				});
			}
			
			return deferredObject.promise();
		}

		function getCCObject(card) {
			var deferredObject = $.Deferred();

			card.expiry = card.expiry.split("/");

			var data =  {
				"type": "card", 
				"card": { 
					"name": card.name ? card.name.trim() : false, 
					"number": card.number ? card.number.trim().replace(/[\s]/g, "") : false, 
					"expiry_month": card.expiry[0] ? card.expiry[0].trim() : false, 
					"expiry_year": card.expiry[1] ? card.expiry[1].trim() : false, 
					"cvv": card.cvc ? card.cvc.trim() : false, 
				} 
			};

			// check if month is invalid
			data.card.expiry_month = parseInt( data.card.expiry_month ) > 12 || parseInt( data.card.expiry_month ) < 1 ? false : data.card.expiry_month;

			var validation_err = [];
			if(!data.card.name) {
				validation_err.push({ message: woocommerce_sumup_gateway_general_params.i18n.empty_name });
			}
			if(!data.card.number) {
				validation_err.push({ message: woocommerce_sumup_gateway_general_params.i18n.empty_card });
			}
			if(!data.card.expiry_month && !data.card.expiry_year) {
				validation_err.push({ message: woocommerce_sumup_gateway_general_params.i18n.empty_expiry });
			} else if(!data.card.expiry_month || !data.card.expiry_year) {
				validation_err.push({ message: woocommerce_sumup_gateway_general_params.i18n.invalid_expiry });
			}
			if(!data.card.cvv) {
				validation_err.push({ message: woocommerce_sumup_gateway_general_params.i18n.empty_cvc });
			}

			if(validation_err.length) {
				deferredObject.reject( validation_err );
				return deferredObject.promise();
			}

			deferredObject.resolve(data.card);
			return deferredObject.promise();
		}

	 
		/**
		* Get credit card token.
		* Promise
		* CORS api call.
		*/
		function getCCToken( card, customer_id ) {
			var deferredObject = $.Deferred();
			var client_id = woocommerce_sumup_gateway_general_params.client_id;

			getCCObject(card).done(function(data){
				var data =  {
					"type": "card", 
					"card": data
				};

				$.ajax({
					type: 'POST',
					url: woocommerce_sumup_gateway_general_params.api.payment_instruments.replace("%customer_id%", customer_id),
					crossDomain: true,
					headers: {"Authorization": "Basic " + client_id },
					data: JSON.stringify(data),
					dataType: "json",
					contentType: "application/json",
					success: function( response ) {
						var res = {
							token: response.token,
							card: response.card,
							customer_id: customer_id,
						};
						res.card.expiry_month = card.expiry[0].trim();
						res.card.expiry_year = card.expiry[1].trim();
						deferredObject.resolve( res );
					},
					error: function( response ) {
						var error = cleanUpError( response.responseJSON );
						deferredObject.reject( error );
					}
				});
			}).fail(function(error) {
				deferredObject.reject( validation_err );
			});

			return deferredObject.promise();
		}

		function cleanUpError( err ) {
			if(err.message) {
				err = [err];
			}

			for(var i in err) {
				var this_err = err[i];
				if(this_err.error_code == "INVALID") {
					switch( this_err.param ) {
						case "card.name":
							this_err.message = woocommerce_sumup_gateway_general_params.i18n.invalid_name;
							break;
						case "card.number":
							this_err.message = woocommerce_sumup_gateway_general_params.i18n.invalid_card;
							break;
						case "card.expiry_month":
						case "card.expiry_year":
							this_err.message = woocommerce_sumup_gateway_general_params.i18n.invalid_expiry;
							break;
						case "card.cvv":
							this_err.message = woocommerce_sumup_gateway_general_params.i18n.invalid_cvc;
							break;
					}
				}
			}
			return err;
		}

		/**
		* Funtion to handle the errors.
		*/
		function errorHandling( err, sumup_cc_fields ) {
			var error_wrapper = sumup_cc_fields.find( '.card-error-wrapper' );

			error_wrapper.html('');

			if(err.message) {
				err = [err];
			}

			var err_list = error_wrapper.find("ul.woocommerce-error");
			if(!err_list.length) {
				err_list = $("<ul>", { "class": "woocommerce-error", "role": "alert" } ).appendTo( error_wrapper );
			}

			for(var i in err) {
				var this_err = err[i];
				err_list.append( $("<li>").text( this_err.message ) );
			}
		}

		/**
		* Manage the return of data to the form. 
		*/
		function addFields( form, data ) {
			if(typeof data.token !== "undefined") {
				$('<input>').attr({
					type: 'hidden',
					id: 'wc-sumup-new-cc-token',
					name: 'wc-sumup-new-cc-token',
					value: data.token
				}).appendTo(form);
			}

			if(typeof data.customer_id !== "undefined") {
				$('<input>').attr({
					type: 'hidden',
					id: 'wc-sumup-customer-id',
					name: 'wc-sumup-customer-id',
					value: data.customer_id
				}).appendTo(form);
			}

			if(typeof data.card !== "undefined") {
				$('<input>').attr({
					type: 'hidden',
					id: 'wc-sumup-new-cc-info',
					name: 'wc-sumup-new-cc-info',
					value: JSON.stringify(data.card)
				}).appendTo(form);
			}

			if(typeof data.paid_checkout_id !== "undefined") {
				$('<input>').attr({
					type: 'hidden',
					id: 'wc-sumup-paid-checkout-id',
					name: 'wc-sumup-paid-checkout-id',
					value: data.paid_checkout_id
				}).appendTo(form);
			}		
		}

		/**
		* Create credit card form.
		*/
		function sumup_cc_form( button_text, form ){ 
			var deferredObject = $.Deferred();
			var sumup_cc_fields = $("<div>", { class: "sumup_fields", style: "display:none" } );
			sumup_cc_fields.append( $("<div>", { class: "card-error-wrapper"} ) );
			sumup_cc_fields.append( $("<div>", { class: "card-wrapper"} ) );
			sumup_cc_fields.append( $("<div>", { class: "form-container"} ) ).append( $('<form>', { class:"credit-card" } ) );

			$('body').append(sumup_cc_fields);

			var cc_form = $( 'form.credit-card' );

			var cc_num = $("<input>", { placeholder: woocommerce_sumup_gateway_general_params.i18n.placeholder_card, type: "text", name: "number" } ).appendTo( cc_form ).wrap("<div/>");
			var cc_name = $("<input>", { placeholder: woocommerce_sumup_gateway_general_params.i18n.placeholder_name, type: "text", name: "name" } ).appendTo( cc_form ).wrap("<div/>");
			var cc_expiry = $("<input>", { placeholder: woocommerce_sumup_gateway_general_params.i18n.placeholder_expiry, type: "text", name: "expiry" } ).appendTo( cc_form ).wrap("<div class='half-width'/>");
			var cc_cvc = $("<input>", { placeholder: woocommerce_sumup_gateway_general_params.i18n.placeholder_cvc, type: "text", name: "cvc" } ).appendTo( cc_form ).wrap("<div class='half-width'/>");
			var cc_submit = $("<input>", { type: "submit", name: "submit", value: button_text, "class": "button alt" } ).appendTo( cc_form ).wrap("<div class='pay'/>");

			cc_form.card({
				container: '.card-wrapper'
			});

			sumup_cc_fields.detach().removeAttr("style");

			var cc_modal = sumup_cc_fields.ignitePopUp({
				width: 392,
				title: woocommerce_sumup_gateway_general_params.i18n.modal_title,
				id: "sumUpPaymentModal"
			});

			form.block({
				message: null,
				overlayCSS: {
					background: '#fff',
					opacity: 0.6
				}
			});

			cc_modal.promise().fail(function() {
				form.unblock();
			});

			cc_form.on( 'submit', function( e ){
				e.preventDefault();
				sumup_cc_fields.parent().block({
					message: null,
					overlayCSS: {
						background: '#fff',
						opacity: 0.6
					}
				}).find( '.card-error-wrapper' ).html('');

				var ccObject = {
					number: cc_num.val(),
					name: cc_name.val(),
					expiry: cc_expiry.val(),
					cvc: cc_cvc.val(),
				};

				var processDef;
				
				if( formIsTokenizing( form ) ) {
					processDef = getClientAndCustomerId( form )
						.then( function( customer_id ){
							return getCCToken(ccObject, customer_id);
						})
						.then( function( response ){ 
							addFields( form, response );

							if( form.is("#add_payment_method") ) {
								cc_modal.trigger("hide.ig.modal");
								form.submit();
								return;
							}

							var checkout_id;
							if( woocommerce_sumup_gateway_general_params.checkout_info ) {
								checkout_id = woocommerce_sumup_gateway_general_params.checkout_info.checkout_id;
							} else {
								return $.Deferred().reject({ message: 'Unknown error.' }).promise();
							}
							
							return completeCheckout(checkout_id, {
								token: response.token,
								customer_id: response.customer_id
							});
						})
				} else {
					processDef = getCCObject(ccObject)
						.then(function(object){
							var checkout_id;
							if( woocommerce_sumup_gateway_general_params.checkout_info ) {
								checkout_id = woocommerce_sumup_gateway_general_params.checkout_info.checkout_id;
							} else {
								return $.Deferred().reject({ message: 'Unknown error.' }).promise();
							}

							return completeCheckout(checkout_id, {
								card: object
							});
						})
				}

				processDef.done(function(checkout_id){
					addFields( form, {
						paid_checkout_id: checkout_id
					} );
					cc_modal.trigger("hide.ig.modal");
					form.submit();
				})

				processDef.fail( function( error ) {
					sumup_cc_fields.parent().unblock();
					return errorHandling( error, sumup_cc_fields )
				} );
			});

			return deferredObject.promise();
		}

		function onSubmit(e) {
			var form = $(this);
			if( ! isSumUpChosen() ) {
				return true;
			}

			if( isSumUpSavedTokenSelected() || ( form.is("#add_payment_method") && isSumUpNewTokenReady() ) || isSumUpCheckoutReady() ) {
				return true;
			}

			var placeOrderButton = $("#place_order");
			var title = placeOrderButton.data("value") || placeOrderButton.text() || placeOrderButton.val();
			var cc_form;
			if(form.is("#add_payment_method")) {
				cc_form = sumup_cc_form(title, form);
				form.unblock();
			} else {
				getCheckoutId(form).then(function(result){
					switch(result.result) {
						case 'sumup_request_payment_info':
							cc_form = sumup_cc_form(title, form);
							break;
						default:
							form.unblock();
							break;
					}
				});
			}

			e.preventDefault();
			return false; //need to return false to cancel the checkout event, also works to preventDefault
		}

		function isSumUpChosen() {
			return $( '#payment_method_sumup' ).is( ':checked' );
		}

		function isSumUpReady() {
			return isSumUpSavedTokenSelected() || isSumUpNewTokenReady();
		}

		function isSumUpSavedTokenSelected() {
			var token_field = $( 'input[name="wc-sumup-payment-token"]:checked' );
			return token_field.length ? 'new' !== $( 'input[name="wc-sumup-payment-token"]:checked' ).val() : false;
		}

		function isSumUpNewTokenReady() {
			return $( 'input[name="wc-sumup-new-cc-token"]' ).length > 0 && $( 'input[name="wc-sumup-new-cc-info"]' ).length > 0 && $( 'input[name="wc-sumup-customer-id"]' ).length > 0;
		}

		function isSumUpCheckoutReady() {
			return $( 'input[name="wc-sumup-paid-checkout-id"]' ).length > 0;
		}

		function needToTokenize(form) {
			return formIsTokenizing(form);
		}

		function formIsTokenizing(form) {
			if( form.is("#add_payment_method") ) {
				return true;
			}

			var paymentMethods = form.find(".payment_method_sumup .wc-saved-payment-methods");
			if( ! paymentMethods.length ) {
				return false;
			}

			if( ! paymentMethods.find( 'input#wc-sumup-payment-token-new' ).is(':checked') ) {
				return false;
			}

			var savePaymentMethodCheck = form.find( 'input#wc-sumup-new-payment-method' );

			if ( ! savePaymentMethodCheck.length || savePaymentMethodCheck.is(":checked") )  {
				return true;
			}

			return false;
		}

		/**
		* Get credit card token.
		* Promise
		* CORS api call.
		*/
		function completeCheckout( checkout_id, data ) {
			var deferredObject = $.Deferred();
			var client_id = woocommerce_sumup_gateway_general_params.client_id;

			data = $.extend(data, {
				"payment_type": "card",
			});

			$.ajax({
				type: 'PUT',
				url: woocommerce_sumup_gateway_general_params.api.complete_checkout.replace("%checkout_id%", checkout_id),
				crossDomain: true,
				headers: {"Authorization": "Basic " + client_id },
				data: JSON.stringify(data),
				dataType: "json",
				contentType: "application/json",
				success: function( response ) {
					if( response.status !== 'PAID' ) {
						deferredObject.reject( cleanUpError( {
							message: 'We were not able to process your payment. Please try again, or try a different Credit Card.',
						} ) );
					} else {
						deferredObject.resolve( response.id );
					}
				},
				error: function( response ) {
					var error = cleanUpError( response.responseJSON );
					deferredObject.reject( error );
				}
			});

			return deferredObject.promise();
		}

		function getCheckoutId($form) {
			var deferredObject = $.Deferred();

			if( woocommerce_sumup_gateway_general_params.checkout_info ) {
				deferredObject.resolve( woocommerce_sumup_gateway_general_params.checkout_info );
			} else {
				$form.addClass( 'processing' );

				var form_data = $form.data();

				if ( 1 !== form_data['blockUI.isBlocked'] ) {
					$form.block({
						message: null,
						overlayCSS: {
							background: '#fff',
							opacity: 0.6
						}
					});
				}

				$.ajax({
					type:		'POST',
					url:		wc_checkout_params.checkout_url,
					data:		$form.serialize() + '&sumup_get_checkout_id=1',
					dataType:   'json',
					success:	function( result ) {
						try {
							if ( 'sumup_request_payment_info' === result.result || 'sumup_complete_payment' === result.result ) {
								woocommerce_sumup_gateway_general_params.checkout_info = result;
								$form.find(":input[name='_wpnonce']").val(result._wpnonce);
								$form.removeClass( 'processing' );
								deferredObject.resolve(result);
							} else {
								throw 'Invalid response';
							}
						} catch( err ) {
							// Add new errors
							if ( typeof result.messages != "undefined" ) {
								submitError( result.messages, $form );
							} else {
								submitError( '<div class="woocommerce-error">' + wc_checkout_params.i18n_checkout_error + '</div>', $form );
							}
							deferredObject.reject();
						}
					},
					error:	function( jqXHR, textStatus, errorThrown ) {
						submitError( '<div class="woocommerce-error">' + errorThrown + '</div>', $form );
						deferredObject.reject();
					}
				});
			}

			return deferredObject.promise();
		}

		function submitError( error_message, $form ) {
			$form.find( '.woocommerce-NoticeGroup-checkout, .woocommerce-error, .woocommerce-message' ).remove();
			$form.prepend( '<div class="woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout">' + error_message + '</div>' );
			$form.removeClass( 'processing' ).unblock();
			$form.find( '.input-text, select, input:checkbox' ).trigger( 'validate' ).blur();
			scrollToNotices();
			$( document.body ).trigger( 'checkout_error' );
		}

		function scrollToNotices() {
			var scrollElement           = $( '.woocommerce-NoticeGroup-updateOrderReview, .woocommerce-NoticeGroup-checkout' ),
				isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

			if ( ! scrollElement.length ) {
				scrollElement = $( '.form.checkout' );
			}

			if ( scrollElement.length ) {
				if ( isSmoothScrollSupported ) {
					scrollElement[0].scrollIntoView({
						behavior: 'smooth'
					});
				} else {
					$( 'html, body' ).animate( {
						scrollTop: ( scrollElement.offset().top - 100 )
					}, 1000 );
				}
			}
		}

		function changeButtonText(button, text) {
			if(button.is("button")) {
				button.text(text);
			} else {
				button.val(text);
			}
		}

		function checkSavedSelected() {
			if( !isSumUpChosen() ) {
				return;
			}

			var button = $("#place_order");

			if( isSumUpSavedTokenSelected() ) {
				changeButtonText(button, button.data("value"));
			} else {
				changeButtonText(button, $( '#payment_method_sumup' ).data('order_button_text'));
			}
		}

		$( document ).on( 'ready', checkSavedSelected );
		$( document.body ).on( 'updated_checkout', checkSavedSelected );
		$( document.body ).on( 'payment_method_selected', checkSavedSelected );
		$( document.body ).on( 'change', ':input.woocommerce-SavedPaymentMethods-tokenInput', checkSavedSelected );
	});
});
//# sourceMappingURL=../../source/_maps/js/frontend/woocommerce-sumup-gateway.js.map
